import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import ReportList from './Component/ReportList';
import { withRouter } from 'react-router-dom';
import Maps from 'containers/Maps';
import IntlMessages from 'util/IntlMessages';

class ReportCollection extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { settings, reports, history, organisationKey } = this.props;
		return (
			<div className="row w-100 m-0 align-items-start">
				{settings.modules.newReport && (
					<div className={`${settings.modules.reportSearch ? 'col-md-6' : ''} col-sm-12`}>
						<Button
							color="default"
							className="jr-btn text-uppercase btn-block custom-main"
							onClick={() => history.push(`/meldoo-web/${organisationKey}/new`)}
						>
							<i className="zmdi zmdi-plus-circle-o zmdi-hc-lg ml-auto" /> <IntlMessages id="meldooWeb.reportCollection.newReport" />
						</Button>
					</div>
				)}
				{settings.modules.reportSearch && (
					<div className={`${settings.modules.newReport ? 'col-md-6' : ''} col-sm-12`}>
						<Button
							color="default"
							className="jr-btn text-uppercase btn-block custom-main"
							onClick={() => history.push(`/meldoo-web/${organisationKey}/search`)}
						>
							<i className="zmdi zmdi-search zmdi-hc-lg ml-auto" />
							<IntlMessages id="meldooWeb.reportCollection.searchReport" />
						</Button>
					</div>
				)}
				<div className="col-12">
					<div className="jr-card p-0 overflow-hidden">
						<Maps
							center={settings.general.mapCenter}
							data={reports}
							types={settings.types}
							dimensions="21by9"
							zoom={settings.general.mapZoom}
							onMarkerClick={
								settings.modules.reportDetails ? reportId => history.push(`/meldoo-web/${organisationKey}/details/${reportId}`) : null
							}
						/>
					</div>
				</div>
				<div className="col-12">
					<ReportList
						reports={reports}
						settings={settings}
						toReport={reportId => history.push(`/meldoo-web/${organisationKey}/details/${reportId}`)}
					/>
				</div>
			</div>
		);
	}
}

function mapStateToProps({ meldooWeb }) {
	const { reports, settings } = meldooWeb;
	return { reports, settings };
}

export default connect(
	mapStateToProps,
	{}
)(withRouter(ReportCollection));



// WEBPACK FOOTER //
// ./containers/MeldooWeb/Pages/ReportCollection/index.js